import React, { useState, useEffect } from 'react';
import { getRuote, getGiocate, createGiocata, deleteGiocata, calcolaCosto, downloadPdfGiocate, downloadPdfGiocata, verificaGiocata, verificaTutteGiocate, getDettaglioGiocata, verificaUltimaEstrazione, verificaSuData, getEstrazioniDisponibili } from '../services/api';

const Giocate = () => {
  const [ruote, setRuote] = useState([]);
  const [giocateList, setGiocateList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [costoCalcolato, setCostoCalcolato] = useState(null);
  const [message, setMessage] = useState(null);
  const [dettaglio, setDettaglio] = useState(null);
  const [verificaLoading, setVerificaLoading] = useState(false);
  const [estrazioniDisponibili, setEstrazioniDisponibili] = useState([]);
  const [showSelectDate, setShowSelectDate] = useState(null);
  
  const [numeriInput, setNumeriInput] = useState('');
  const [selectedRuote, setSelectedRuote] = useState([]);
  const [importoAmbo, setImportoAmbo] = useState(0);
  const [importoTerno, setImportoTerno] = useState(0);
  const [importoQuaterna, setImportoQuaterna] = useState(0);
  const [importoCinquina, setImportoCinquina] = useState(0);
  const [dataGiocata, setDataGiocata] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [ruoteRes, giocateRes, estrazioniRes] = await Promise.all([
        getRuote(),
        getGiocate(),
        getEstrazioniDisponibili(50)
      ]);
      setRuote(ruoteRes.data);
      setGiocateList(giocateRes.data);
      setEstrazioniDisponibili(estrazioniRes.data);
    } catch (err) {
      console.error('Errore:', err);
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 5000);
  };

  const handleCalcolaCosto = async () => {
    const numeri = numeriInput.split(',').map(n => parseInt(n.trim())).filter(n => n >= 1 && n <= 90);
    if (numeri.length < 2) {
      alert('Inserisci almeno 2 numeri');
      return;
    }
    
    if (selectedRuote.length === 0) {
      alert('Seleziona almeno una ruota');
      return;
    }

    if (importoAmbo <= 0 && importoTerno <= 0 && importoQuaterna <= 0 && importoCinquina <= 0) {
      alert('Inserisci almeno un importo');
      return;
    }

    try {
      const res = await calcolaCosto(
        numeri.join(','),
        selectedRuote.join(','),
        importoAmbo,
        importoTerno,
        importoQuaterna,
        importoCinquina
      );
      setCostoCalcolato(res.data);
    } catch (err) {
      alert('Errore calcolo costo');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const numeri = numeriInput.split(',').map(n => parseInt(n.trim())).filter(n => n >= 1 && n <= 90);
    if (numeri.length < 2) {
      alert('Inserisci almeno 2 numeri validi (1-90)');
      return;
    }

    if (selectedRuote.length === 0) {
      alert('Seleziona almeno una ruota');
      return;
    }

    if (importoAmbo <= 0 && importoTerno <= 0 && importoQuaterna <= 0 && importoCinquina <= 0) {
      alert('Inserisci almeno un importo');
      return;
    }

    try {
      await createGiocata({
        numeri,
        ruote: selectedRuote,
        importo_ambo: importoAmbo,
        importo_terno: importoTerno,
        importo_quaterna: importoQuaterna,
        importo_cinquina: importoCinquina,
        data_giocata: dataGiocata
      });
      
      setNumeriInput('');
      setSelectedRuote([]);
      setImportoAmbo(0);
      setImportoTerno(0);
      setImportoQuaterna(0);
      setImportoCinquina(0);
      setCostoCalcolato(null);
      setShowForm(false);
      
      loadData();
      showMessage('Giocata registrata!');
    } catch (err) {
      alert(err.response?.data?.detail || 'Errore nel salvataggio');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminare questa giocata?')) return;
    
    try {
      await deleteGiocata(id);
      loadData();
      showMessage('Giocata eliminata');
    } catch (err) {
      alert('Errore eliminazione');
    }
  };

  const handleVerificaSingola = async (id) => {
    setVerificaLoading(true);
    try {
      const res = await verificaGiocata(id);
      setDettaglio(res.data);
      loadData();
      
      if (res.data.vincita_totale > 0) {
        showMessage('HAI VINTO EUR ' + res.data.vincita_totale.toFixed(2) + '!', 'success');
      } else if (res.data.stato === 'persa') {
        showMessage('Nessuna vincita questa volta', 'error');
      }
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore verifica', 'error');
    } finally {
      setVerificaLoading(false);
    }
  };

  const handleVerificaTutte = async () => {
    setVerificaLoading(true);
    try {
      const res = await verificaTutteGiocate();
      loadData();
      
      if (res.data.totale_vinto > 0) {
        showMessage('Totale vinto: EUR ' + res.data.totale_vinto.toFixed(2) + ' su ' + res.data.n_vinte + ' giocate!', 'success');
      } else {
        showMessage('Verificate ' + res.data.n_verificate + ' giocate. Nessuna vincita.', 'error');
      }
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore verifica', 'error');
    } finally {
      setVerificaLoading(false);
    }
  };

  const handleVerificaUltima = async (id) => {
    setVerificaLoading(true);
    try {
      const res = await verificaUltimaEstrazione(id);
      setDettaglio(res.data);
      
      if (res.data.vincita_totale > 0) {
        showMessage('HAI VINTO EUR ' + res.data.vincita_totale.toFixed(2) + '!', 'success');
      } else {
        showMessage('Nessuna vincita su estrazione del ' + res.data.data_estrazione, 'error');
      }
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore verifica', 'error');
    } finally {
      setVerificaLoading(false);
    }
  };

  const handleVerificaSuData = async (id, data) => {
    setVerificaLoading(true);
    setShowSelectDate(null);
    try {
      const res = await verificaSuData(id, data);
      setDettaglio(res.data);
      
      if (res.data.vincita_totale > 0) {
        showMessage('HAI VINTO EUR ' + res.data.vincita_totale.toFixed(2) + '!', 'success');
      } else {
        showMessage('Nessuna vincita su estrazione del ' + data, 'error');
      }
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore verifica', 'error');
    } finally {
      setVerificaLoading(false);
    }
  };

  const handleVediDettaglio = async (id) => {
    try {
      const res = await getDettaglioGiocata(id);
      setDettaglio(res.data);
    } catch (err) {
      showMessage('Errore caricamento dettaglio', 'error');
    }
  };

  const handleDownloadPdfTutte = async () => {
    try {
      const res = await downloadPdfGiocate();
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'giocate.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Errore download PDF');
    }
  };

  const handleDownloadPdfSingola = async (id) => {
    try {
      const res = await downloadPdfGiocata(id);
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'giocata_' + id + '.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Errore download PDF');
    }
  };

  const toggleRuota = (ruotaId) => {
    setSelectedRuote(prev => 
      prev.includes(ruotaId) 
        ? prev.filter(r => r !== ruotaId)
        : [...prev, ruotaId]
    );
    setCostoCalcolato(null);
  };

  const selectAllRuote = () => {
    if (selectedRuote.length === ruote.length) {
      setSelectedRuote([]);
    } else {
      setSelectedRuote(ruote.map(r => r.id));
    }
    setCostoCalcolato(null);
  };

  const getStatoColor = (stato) => {
    switch(stato) {
      case 'vinta': return { bg: '#c6f6d5', color: '#22543d' };
      case 'persa': return { bg: '#fed7d7', color: '#822727' };
      default: return { bg: '#fef3c7', color: '#92400e' };
    }
  };

  const formatTipo = (g) => {
    const tipi = [];
    if (g.importo_ambo > 0) tipi.push('A');
    if (g.importo_terno > 0) tipi.push('T');
    if (g.importo_quaterna > 0) tipi.push('Q');
    if (g.importo_cinquina > 0) tipi.push('C');
    return tipi.join('+') || g.tipo;
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <h2>Giocate</h2>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button 
            className="btn btn-success" 
            onClick={handleVerificaTutte}
            disabled={verificaLoading}
          >
            {verificaLoading ? 'Attendi...' : 'Verifica Tutte'}
          </button>
          <button className="btn btn-secondary" onClick={handleDownloadPdfTutte}>
            Esporta PDF
          </button>
          <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
            {showForm ? 'Chiudi' : 'Nuova Giocata'}
          </button>
        </div>
      </div>

      {message && (
        <div className={'alert alert-' + (message.type === 'error' ? 'error' : 'success')}>
          {message.text}
        </div>
      )}

      {dettaglio && (
        <div className="card" style={{ marginBottom: '20px', border: '2px solid #2c5282' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <h3 className="card-title" style={{ margin: 0 }}>
              Dettaglio Giocata - {dettaglio.giocata?.data_giocata || dettaglio.data_giocata}
              {dettaglio.data_estrazione && dettaglio.data_estrazione !== (dettaglio.giocata?.data_giocata || dettaglio.data_giocata) && (
                <span style={{ fontSize: '0.8rem', color: '#718096' }}> (vs estrazione {dettaglio.data_estrazione})</span>
              )}
            </h3>
            <button 
              className="btn btn-secondary" 
              onClick={() => setDettaglio(null)}
              style={{ padding: '5px 10px' }}
            >
              X
            </button>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <strong>Numeri giocati:</strong>
            <div style={{ display: 'flex', gap: '5px', marginTop: '5px', flexWrap: 'wrap' }}>
              {(dettaglio.giocata?.numeri || dettaglio.numeri_giocati || []).map(n => (
                <span key={n} className="numero-ball">{n}</span>
              ))}
            </div>
          </div>

          {dettaglio.importi && (
            <div style={{ marginBottom: '15px', fontSize: '0.9rem', color: '#4a5568' }}>
              <strong>Importi per combinazione:</strong>{' '}
              {dettaglio.importi.ambo > 0 && <span>Ambo: EUR {dettaglio.importi.ambo} </span>}
              {dettaglio.importi.terno > 0 && <span>| Terno: EUR {dettaglio.importi.terno} </span>}
              {dettaglio.importi.quaterna > 0 && <span>| Quaterna: EUR {dettaglio.importi.quaterna} </span>}
              {dettaglio.importi.cinquina > 0 && <span>| Cinquina: EUR {dettaglio.importi.cinquina}</span>}
            </div>
          )}

          {dettaglio.vincita_totale !== undefined && (
            <div style={{ marginBottom: '15px', padding: '10px', borderRadius: '8px', background: dettaglio.vincita_totale > 0 ? '#c6f6d5' : '#fed7d7' }}>
              <strong>Risultato: </strong>
              {dettaglio.vincita_totale > 0 ? (
                <span style={{ color: '#22543d' }}>
                  VINTO EUR {dettaglio.vincita_totale.toFixed(2)}
                  {dettaglio.tipi_vincita && dettaglio.tipi_vincita.length > 0 && 
                    ' (' + dettaglio.tipi_vincita.map(t => t.toUpperCase()).join(', ') + ')'
                  }
                </span>
              ) : (
                <span style={{ color: '#822727' }}>Nessuna vincita</span>
              )}
            </div>
          )}

          {dettaglio.nota && (
            <div style={{ marginBottom: '15px', padding: '8px', background: '#fef3c7', borderRadius: '4px', fontSize: '0.85rem' }}>
              {dettaglio.nota}
            </div>
          )}

          <div>
            <strong>Confronto con estrazioni:</strong>
            {(dettaglio.estrazioni || dettaglio.risultati_ruote || []).length === 0 ? (
              <p style={{ color: '#718096', marginTop: '10px' }}>
                Estrazione non ancora disponibile per questa data
              </p>
            ) : (
              <div style={{ marginTop: '10px' }}>
                {(dettaglio.estrazioni || dettaglio.risultati_ruote || []).map((e, idx) => (
                  <div 
                    key={idx} 
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '10px', 
                      padding: '10px',
                      background: e.numeri_indovinati?.length >= 2 ? '#f0fff4' : '#f7fafc',
                      borderRadius: '8px',
                      marginBottom: '8px',
                      flexWrap: 'wrap'
                    }}
                  >
                    <span className="ruota-badge" style={{ minWidth: '80px', textAlign: 'center' }}>
                      {e.ruota_nome}
                    </span>
                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                      {e.numeri_estratti?.map((n, i) => (
                        <span 
                          key={i} 
                          className="numero-ball"
                          style={{
                            background: e.numeri_indovinati?.includes(n) 
                              ? 'linear-gradient(135deg, #48bb78, #38a169)' 
                              : undefined,
                            boxShadow: e.numeri_indovinati?.includes(n)
                              ? '0 0 10px rgba(72, 187, 120, 0.5)'
                              : undefined
                          }}
                        >
                          {n}
                        </span>
                      ))}
                    </div>
                    {e.numeri_indovinati?.length > 0 && (
                      <div style={{ 
                        color: '#22543d', 
                        fontWeight: 'bold',
                        background: '#c6f6d5',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        fontSize: '0.85rem'
                      }}>
                        <div>{e.n_indovinati || e.numeri_indovinati.length} numeri indovinati</div>
                        {e.vincita_dettaglio && (
                          <div style={{ marginTop: '5px', fontWeight: 'normal' }}>
                            {e.vincita_dettaglio.ambo?.combinazioni_vinte > 0 && (
                              <div>Ambo: {e.vincita_dettaglio.ambo.combinazioni_vinte} x EUR {(e.vincita_dettaglio.ambo.importo_vinto / e.vincita_dettaglio.ambo.combinazioni_vinte).toFixed(2)} = EUR {e.vincita_dettaglio.ambo.importo_vinto.toFixed(2)}</div>
                            )}
                            {e.vincita_dettaglio.terno?.combinazioni_vinte > 0 && (
                              <div>Terno: {e.vincita_dettaglio.terno.combinazioni_vinte} x EUR {(e.vincita_dettaglio.terno.importo_vinto / e.vincita_dettaglio.terno.combinazioni_vinte).toFixed(2)} = EUR {e.vincita_dettaglio.terno.importo_vinto.toFixed(2)}</div>
                            )}
                            {e.vincita_dettaglio.quaterna?.combinazioni_vinte > 0 && (
                              <div>Quaterna: {e.vincita_dettaglio.quaterna.combinazioni_vinte} x EUR {(e.vincita_dettaglio.quaterna.importo_vinto / e.vincita_dettaglio.quaterna.combinazioni_vinte).toFixed(2)} = EUR {e.vincita_dettaglio.quaterna.importo_vinto.toFixed(2)}</div>
                            )}
                            {e.vincita_dettaglio.cinquina?.combinazioni_vinte > 0 && (
                              <div>Cinquina: {e.vincita_dettaglio.cinquina.combinazioni_vinte} x EUR {(e.vincita_dettaglio.cinquina.importo_vinto / e.vincita_dettaglio.cinquina.combinazioni_vinte).toFixed(2)} = EUR {e.vincita_dettaglio.cinquina.importo_vinto.toFixed(2)}</div>
                            )}
                          </div>
                        )}
                        {e.importo_vinto > 0 && (
                          <div style={{ marginTop: '5px', fontWeight: 'bold' }}>Totale ruota: EUR {e.importo_vinto.toFixed(2)}</div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {showForm && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3 className="card-title" style={{ marginBottom: '20px' }}>Nuova Giocata</h3>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Numeri (separati da virgola, max 10)</label>
              <input
                type="text"
                className="form-input"
                value={numeriInput}
                onChange={(e) => { setNumeriInput(e.target.value); setCostoCalcolato(null); }}
                placeholder="Es: 7, 23, 45, 67"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                Ruote 
                <button 
                  type="button" 
                  onClick={selectAllRuote}
                  style={{ marginLeft: '10px', fontSize: '0.8rem', background: 'none', border: 'none', color: '#2c5282', cursor: 'pointer' }}
                >
                  {selectedRuote.length === ruote.length ? '(Deseleziona tutte)' : '(Seleziona tutte)'}
                </button>
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {ruote.map((r) => (
                  <span
                    key={r.id}
                    className="ruota-badge"
                    style={{
                      cursor: 'pointer',
                      background: selectedRuote.includes(r.id) ? '#2c5282' : '#e2e8f0',
                      color: selectedRuote.includes(r.id) ? 'white' : '#4a5568'
                    }}
                    onClick={() => toggleRuota(r.id)}
                  >
                    {r.nome}
                  </span>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '20px', padding: '15px', background: '#f7fafc', borderRadius: '8px' }}>
              <label className="form-label" style={{ marginBottom: '15px', display: 'block' }}>
                Importi per combinazione (EUR) - Come in ricevitoria
              </label>
              <div className="grid grid-4" style={{ gap: '15px' }}>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label" style={{ fontSize: '0.85rem' }}>Ambo (min 2 num)</label>
                  <input
                    type="number"
                    className="form-input"
                    value={importoAmbo}
                    onChange={(e) => { setImportoAmbo(parseFloat(e.target.value) || 0); setCostoCalcolato(null); }}
                    min="0"
                    step="0.5"
                    placeholder="0"
                  />
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label" style={{ fontSize: '0.85rem' }}>Terno (min 3 num)</label>
                  <input
                    type="number"
                    className="form-input"
                    value={importoTerno}
                    onChange={(e) => { setImportoTerno(parseFloat(e.target.value) || 0); setCostoCalcolato(null); }}
                    min="0"
                    step="0.5"
                    placeholder="0"
                  />
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label" style={{ fontSize: '0.85rem' }}>Quaterna (min 4 num)</label>
                  <input
                    type="number"
                    className="form-input"
                    value={importoQuaterna}
                    onChange={(e) => { setImportoQuaterna(parseFloat(e.target.value) || 0); setCostoCalcolato(null); }}
                    min="0"
                    step="0.5"
                    placeholder="0"
                  />
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label" style={{ fontSize: '0.85rem' }}>Cinquina (min 5 num)</label>
                  <input
                    type="number"
                    className="form-input"
                    value={importoCinquina}
                    onChange={(e) => { setImportoCinquina(parseFloat(e.target.value) || 0); setCostoCalcolato(null); }}
                    min="0"
                    step="0.5"
                    placeholder="0"
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Data Giocata</label>
              <input
                type="date"
                className="form-input"
                style={{ maxWidth: '200px' }}
                value={dataGiocata}
                onChange={(e) => setDataGiocata(e.target.value)}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <button type="button" className="btn btn-secondary" onClick={handleCalcolaCosto}>
                Calcola Costo
              </button>
            </div>

            {costoCalcolato && (
              <div 
                className={'alert ' + (costoCalcolato.warning ? 'alert-warning' : 'alert-success')}
                style={{ marginBottom: '20px' }}
              >
                <strong>Costo Totale: EUR {costoCalcolato.costo_totale.toFixed(2)}</strong>
                {costoCalcolato.warning && (
                  <span> - {costoCalcolato.warning}</span>
                )}
                <div style={{ fontSize: '0.85rem', marginTop: '10px' }}>
                  {costoCalcolato.dettaglio.ambo.combinazioni > 0 && (
                    <div>Ambo: EUR {costoCalcolato.dettaglio.ambo.importo_totale.toFixed(2)} ({costoCalcolato.dettaglio.ambo.combinazioni} comb x EUR {costoCalcolato.dettaglio.ambo.importo_per_comb.toFixed(2)} per comb)</div>
                  )}
                  {costoCalcolato.dettaglio.terno.combinazioni > 0 && (
                    <div>Terno: EUR {costoCalcolato.dettaglio.terno.importo_totale.toFixed(2)} ({costoCalcolato.dettaglio.terno.combinazioni} comb x EUR {costoCalcolato.dettaglio.terno.importo_per_comb.toFixed(2)} per comb)</div>
                  )}
                  {costoCalcolato.dettaglio.quaterna.combinazioni > 0 && (
                    <div>Quaterna: EUR {costoCalcolato.dettaglio.quaterna.importo_totale.toFixed(2)} ({costoCalcolato.dettaglio.quaterna.combinazioni} comb x EUR {costoCalcolato.dettaglio.quaterna.importo_per_comb.toFixed(2)} per comb)</div>
                  )}
                  {costoCalcolato.dettaglio.cinquina.combinazioni > 0 && (
                    <div>Cinquina: EUR {costoCalcolato.dettaglio.cinquina.importo_totale.toFixed(2)} ({costoCalcolato.dettaglio.cinquina.combinazioni} comb x EUR {costoCalcolato.dettaglio.cinquina.importo_per_comb.toFixed(2)} per comb)</div>
                  )}
                </div>
              </div>
            )}
            <div style={{ display: 'flex', gap: '10px' }}>
              <button type="submit" className="btn btn-success">
                Registra Giocata
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
                Annulla
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="card">
        <h3 className="card-title" style={{ marginBottom: '20px' }}>Storico Giocate</h3>
        
        {giocateList.length === 0 ? (
          <p style={{ color: '#718096', textAlign: 'center', padding: '20px' }}>
            Nessuna giocata registrata.
          </p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Numeri</th>
                <th>Ruote</th>
                <th>Tipo</th>
                <th>Costo</th>
                <th>Stato</th>
                <th>Vincita</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {giocateList.map((g) => (
                <tr key={g.id}>
                  <td>{new Date(g.data_giocata).toLocaleDateString('it-IT')}</td>
                  <td>
                    {g.numeri.map((n) => (
                      <span key={n} className="numero-ball small">{n}</span>
                    ))}
                  </td>
                  <td>
                    {g.ruote.map((rId) => {
                      const ruota = ruote.find(r => r.id === rId);
                      return ruota ? (
                        <span key={rId} className="ruota-badge" style={{ fontSize: '0.7rem' }}>
                          {ruota.codice}
                        </span>
                      ) : null;
                    })}
                  </td>
                  <td style={{ textTransform: 'uppercase', fontSize: '0.8rem' }}>{formatTipo(g)}</td>
                  <td>EUR {parseFloat(g.importo).toFixed(2)}</td>
                  <td>
                    <span 
                      className="ruota-badge" 
                      style={{ 
                        background: getStatoColor(g.stato).bg, 
                        color: getStatoColor(g.stato).color 
                      }}
                    >
                      {g.stato.toUpperCase()}
                    </span>
                  </td>
                  <td>
                    {g.vincita > 0 ? (
                      <span style={{ color: '#22543d', fontWeight: 'bold' }}>
                        EUR {parseFloat(g.vincita).toFixed(2)}
                      </span>
                    ) : '-'}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', position: 'relative' }}>
                      <button 
                        className="btn btn-primary" 
                        style={{ padding: '3px 8px', fontSize: '0.75rem' }}
                        onClick={() => handleVediDettaglio(g.id)}
                        title="Vedi dettaglio"
                      >
                        Dettaglio
                      </button>
                      {g.stato === 'attiva' && (
                        <button 
                          className="btn btn-success" 
                          style={{ padding: '3px 8px', fontSize: '0.75rem' }}
                          onClick={() => handleVerificaSingola(g.id)}
                          disabled={verificaLoading}
                          title="Verifica vincita"
                        >
                          Verifica
                        </button>
                      )}
                      <button 
                        className="btn btn-warning" 
                        style={{ padding: '3px 8px', fontSize: '0.75rem', background: '#ed8936', color: 'white' }}
                        onClick={() => handleVerificaUltima(g.id)}
                        disabled={verificaLoading}
                        title="Verifica su ultima estrazione"
                      >
                        Ultima
                      </button>
                      <button 
                        className="btn btn-info" 
                        style={{ padding: '3px 8px', fontSize: '0.75rem', background: '#4299e1', color: 'white' }}
                        onClick={() => setShowSelectDate(showSelectDate === g.id ? null : g.id)}
                        title="Verifica su data specifica"
                      >
                        Storico
                      </button>
                      {showSelectDate === g.id && (
                        <div style={{ 
                          position: 'absolute', 
                          top: '100%', 
                          left: 0, 
                          background: 'white', 
                          border: '1px solid #e2e8f0',
                          borderRadius: '8px',
                          padding: '10px',
                          zIndex: 100,
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          maxHeight: '200px',
                          overflowY: 'auto'
                        }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '0.85rem' }}>Seleziona estrazione:</div>
                          {estrazioniDisponibili.map(e => (
                            <div 
                              key={e.data}
                              style={{ 
                                padding: '5px 10px', 
                                cursor: 'pointer',
                                borderRadius: '4px',
                                fontSize: '0.85rem'
                              }}
                              className="hover-bg"
                              onClick={() => handleVerificaSuData(g.id, e.data)}
                            >
                              {e.label}
                            </div>
                          ))}
                        </div>
                      )}
                      <button 
                        className="btn btn-secondary" 
                        style={{ padding: '3px 8px', fontSize: '0.75rem' }}
                        onClick={() => handleDownloadPdfSingola(g.id)}
                        title="Scarica PDF"
                      >
                        PDF
                      </button>
                      <button 
                        className="btn btn-danger" 
                        style={{ padding: '3px 8px', fontSize: '0.75rem' }}
                        onClick={() => handleDelete(g.id)}
                        title="Elimina"
                      >
                        Elimina
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <style>{`
        .hover-bg:hover {
          background: #f7fafc;
        }
        .grid-4 {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
        }
        @media (max-width: 768px) {
          .grid-4 {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        .alert-warning {
          background: #fef3c7;
          border: 1px solid #f59e0b;
          color: #92400e;
        }
      `}</style>
    </div>
  );
};

export default Giocate;
